require('./angular/app.js');
require('./angular/controllers/PitchMyPlaylistsCtrl.js');


// WEBPACK FOOTER //
// ./src/PlaylistClientBundle/Resources/js/index.js